import { render, staticRenderFns } from "./EditSubCategory.vue?vue&type=template&id=72fc142b&scoped=true&"
import script from "./EditSubCategory.vue?vue&type=script&lang=js&"
export * from "./EditSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc142b",
  null
  
)

export default component.exports